import React, { useCallback, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton, CustomModal } from '@shared/ui';
import { TFilesModalMode } from '@widgets/Files/model/types/modalMode.type';

import cls from './ModalFiles.module.css';
import { useModalFiles } from './useModalFiles';

interface IDeleteProps {
    onHideModal: () => void;
    isShow: boolean;
    mode?: TFilesModalMode;
}

export const Delete = ({ onHideModal, isShow, mode }: IDeleteProps) => {
    const { t } = useTranslation();
    const { onDeleteFile, onDeleteFolder } = useModalFiles(onHideModal);
    const deleteBtnRef = useRef(null);

    const handleEscapeDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onHideModal();
            }
            if (event.key === 'Enter' && mode === 'delete') {
                onDeleteFile();
            }
            if (event.key === 'Enter' && mode === 'folderDelete') {
                onDeleteFolder();
            }
        },
        [mode, onDeleteFile, onDeleteFolder, onHideModal]
    );

    useEffect(() => {
        if (isShow) {
            deleteBtnRef.current.focus();
            document.addEventListener('keydown', handleEscapeDown);
        }
        return () => {
            document.removeEventListener('keydown', handleEscapeDown);
        };
    }, [isShow, onHideModal, handleEscapeDown]);
    return (
        <>
            <CustomModal.Body classes={cls.textAlignCenter}>
                {mode === 'folderDelete' && t('Delete.FolderDelete.ModalBody.confirmDelete')}
                {mode === 'delete' && t('Delete.return.ModalBody.confirmDelete')}
            </CustomModal.Body>
            <CustomModal.Footer classes={cls.textAlignCenterFooter}>
                <UiButton
                    variant="contained"
                    btnColor="danger"
                    innerRef={deleteBtnRef}
                    className={cls.deleteModalBtn}
                    btnText={t('Delete.return.ModalFooter.deleteButton')}
                    onClick={() => {
                        if (mode === 'delete') {
                            onDeleteFile();
                        }
                        if (mode === 'folderDelete') {
                            onDeleteFolder();
                        }
                    }}
                />
                <UiButton
                    btnText={t('Delete.return.ModalFooter.cancelButton')}
                    btnColor="ghost"
                    onClick={onHideModal}
                    className={cls.deleteModalBtn}
                />
            </CustomModal.Footer>
        </>
    );
};
